import styles from './topBar.module.css'
import { Icon } from './icons'
import type { IconName } from './icons'
import type { TopBarValues } from './slots'

export type TopAction = 'tasks' | 'profile' | 'shop' | 'settings'

const BUTTONS: readonly { id: TopAction; label: string; icon: IconName }[] = [
  { id: 'tasks', label: 'Tasks', icon: 'tasks' },
  { id: 'profile', label: 'Profile', icon: 'profile' },
  { id: 'shop', label: 'Shop', icon: 'shop' },
  { id: 'settings', label: 'Settings', icon: 'settings' },
]

const fmt = (n: number): string => n.toLocaleString('en-US')

/**
 * Top bar (PHASE3 T3.1): coins (gold shard), gems (violet gem), level badge and XP bar on the
 * left; round Tasks / Profile / Shop / Settings buttons on the right.
 */
export function TopBar({
  values,
  name,
  onAction,
}: {
  values: TopBarValues
  name: string
  onAction: (a: TopAction) => void
}) {
  return (
    <header class={styles.topBar}>
      <div class={styles.wallet}>
        <div class={styles.level} title={`Level ${values.level}`}>
          <span class={styles.levelBadge} data-testid="level">
            Lv {values.level}
          </span>
          <span class={styles.levelMeta}>
            <span class={styles.playerName}>{name}</span>
            <span class={styles.xpBar} aria-label="Experience">
              <span class={styles.xpFill} style={{ width: `${Math.round(values.xp * 100)}%` }} />
            </span>
          </span>
        </div>
        <div class={styles.money} title="Coins">
          <span class={styles.coinIcon} aria-hidden="true" />
          <span data-testid="coins">{fmt(values.coins)}</span>
          <span class={styles.srOnly}> coins</span>
        </div>
        <div class={styles.money} title="Gems">
          <span class={styles.gemIcon} aria-hidden="true" />
          <span data-testid="gems">{fmt(values.gems)}</span>
          <span class={styles.srOnly}> gems</span>
        </div>
      </div>
      <nav class={styles.roundButtons} aria-label="Hub">
        {BUTTONS.map((b) => (
          <button
            key={b.id}
            type="button"
            class={styles.roundButton}
            onClick={() => onAction(b.id)}
            aria-label={b.label}
          >
            <Icon name={b.icon} />
            <span class={styles.roundLabel}>{b.label}</span>
          </button>
        ))}
      </nav>
    </header>
  )
}
